/* eslint-disable */
import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import { IGetOfferDataRequest, TGetOfferDataModel, IMappers, TGetOfferDataResponse } from './types';
import { IAllOfferDataSchema } from '../../entities/all_offer_data/AllOfferDataSchema';
import { IErrorResponseSchema } from '../../../../../shared/repositories/offer-card/entities/schemas/ErrorResponseSchema';

export const defaultConfig: TGetOfferDataModel = {
  apiType: 'private',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'offer-card',
  pathApi: '/v1/get-offer-data/',
  responseType: 'json',
} as TGetOfferDataModel;

export function createGetOfferDataModel(parameters: IGetOfferDataRequest): TGetOfferDataModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetOfferDataOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetOfferDataRequest;
}

export async function fetchGetOfferData<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetOfferDataOptions<TResponse200, TResponse400>): Promise<TGetOfferDataResponse | TResponse200 | TResponse400> {
  const { statusCode, response, headers } = await httpApi.fetch(createGetOfferDataModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IAllOfferDataSchema);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetOfferDataResponse;
}
